import _objectSpread from'@babel/runtime/helpers/objectSpread2';import React,{useRef,useEffect}from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import {MESSAGE_VARIANT,MessageCard}from'@manulife/mux';import {shouldShowError}from'../../utils/functions.js';import {ErrorShape}from'../../utils/propTypes.js';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';import CIAMLink from'../CIAMLink/CIAMLink.js';var ERROR_TYPE_MAP = {
  L1: MESSAGE_VARIANT.HARDSTOP,
  L2: MESSAGE_VARIANT.PRIMARY_ALERT,
  L3: MESSAGE_VARIANT.SECONDARY_ALERT
};
var commonErrorAlertValues = {
  SignInLink: function SignInLink() {
    for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
      chunks[_key] = arguments[_key];
    }
    return /*#__PURE__*/React.createElement(CIAMLink, {
      to: "/"
    }, chunks);
  }
};
var ErrorAlert = function ErrorAlert(_ref) {
  var error = _ref.error,
    errorFor = _ref.errorFor,
    errorValues = _ref.errorValues,
    callouts = _ref.callouts;
  var errorRef = useRef(null);
  var intl = useIntl();
  useEffect(function () {
    if (shouldShowError(error, errorFor) && errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      errorRef.current.focus({
        preventScroll: true
      }); // preventScroll: true will make focus not interfere with the scrollIntoView
    }
  }, [error, errorFor, errorRef]);
  if (!shouldShowError(error, errorFor)) {
    return null;
  }
  var errorCode = error.errorCode || '';
  var values = _objectSpread(_objectSpread({}, commonErrorAlertValues), error.values);
  var variant = ERROR_TYPE_MAP[error.errorType] || MESSAGE_VARIANT.PRIMARY_ALERT;
  var titleText = error.title ? intl.formatMessage({
    id: error.title
  }, values) : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "error-alert error-alert-".concat(errorCode),
    ref: errorRef,
    role: "alert",
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(MessageCard, {
    variant: variant,
    titleText: titleText,
    "aria-live": callouts ? 'polite' : 'off'
  }, error.message && /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: error.message,
    values: values,
    errorValues: errorValues
  })));
};
process.env.NODE_ENV !== "production" ? ErrorAlert.propTypes = {
  error: ErrorShape,
  errorFor: PropTypes.string,
  errorValues: PropTypes.shape({
    id: PropTypes.string
  }),
  callouts: PropTypes.bool
} : void 0;
ErrorAlert.defaultProps = {
  error: {},
  errorFor: 'global',
  errorValues: {},
  callouts: false
};
var ErrorAlert$1 = ErrorAlert;export{ErrorAlert$1 as default};